import React from 'react'

import { MenuItemProps } from './models'

export const MenuItem: React.FC<MenuItemProps> = ({ children }) => {
  return <>{children}</>
}

MenuItem.displayName = 'MenuItem'
